import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getTenantPermissionInfo = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.COMMON.GET_TENANT_PERMISSION_INFO
  );
};

export default getTenantPermissionInfo;
